// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"9cc7f8d3","266":"5358af8c","474":"de326135","584":"23d23cfa","595":"b798a36f","602":"fff13544","704":"67e65c3e","900":"c5d0e206"}[chunkId] + ".chunk.css";
};